export const tonsToLbs = (tons) => tons * 2204.62;

export const lbsToTons = (lbs) => lbs / 2204.62;

export const kgsToLbs = (kgs) => kgs * 2.20462;

export const kgsToTons = (kgs) => kgs / 1000;
